import { LinkPreview, LinkPreviewDAO } from 'sparkello-core';
import { firestore } from 'firebase/app';

import DocumentSnapshot = firestore.DocumentSnapshot;
import { LinkPreviewMapper } from 'sparkello-core/dao/linkPreview/LinkPreviewMapper';

export class LinkPreviewWebMapper implements LinkPreviewMapper<DocumentSnapshot>{
  public mapToLocalLinkPreview(doc): LinkPreview {
    return {
      id: doc?.id,
      url: doc?.data()?.url,
      title: doc?.data()?.title,
      description: doc?.data()?.description,
      image: doc?.data()?.image,
      type: doc?.data()?.type,
      charset: doc?.data()?.type,
    } as LinkPreview;
  }
}

export class LinkPreviewWebDAO extends LinkPreviewDAO<DocumentSnapshot, typeof firestore>{
  private static singleton: LinkPreviewWebDAO;

  public static get instance(): LinkPreviewWebDAO {
    if (!LinkPreviewWebDAO.singleton) {
      LinkPreviewWebDAO.singleton = new LinkPreviewWebDAO();
    }
    return this.singleton;
  }

  public constructor() {
    super(new LinkPreviewWebMapper(), firestore);
    return this;
  }
}
